import { render } from "./BuilderHouseBorrowCalculator.vue?vue&type=template&id=6a230562&scoped=true&ts=true&lang=pug"
import script from "./BuilderHouseBorrowCalculator.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderHouseBorrowCalculator.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderHouseBorrowCalculator.vue?vue&type=style&index=0&id=6a230562&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a230562"]])

export default __exports__